var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganizationManagementInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 120,
    viewBox: "0 0 150 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 63.75H69.375V75H80.625V63.75H125.625V75H136.875V61.6406C136.875 56.7188 132.656 52.5 127.734 52.5H80.625V37.5H90C93.9844 37.5 97.5 34.2188 97.5 30V7.5C97.5 3.51562 93.9844 0 90 0H60C55.7812 0 52.5 3.51562 52.5 7.5V30C52.5 32.1094 53.2031 33.9844 54.6094 35.3906C56.0156 36.7969 57.8906 37.5 60 37.5H69.375V52.5H22.0312C17.1094 52.5 13.125 56.7188 13.125 61.6406V75H24.375V63.75ZM63.75 26.25V11.25H86.25V26.25H63.75ZM142.5 82.5H120C115.781 82.5 112.5 86.0156 112.5 90V112.5C112.5 116.719 115.781 120 120 120H142.5C146.484 120 150 116.719 150 112.5V90C150 86.0156 146.484 82.5 142.5 82.5ZM138.75 108.75H123.75V93.75H138.75V108.75ZM86.25 82.5H63.75C59.5312 82.5 56.25 86.0156 56.25 90V112.5C56.25 116.719 59.5312 120 63.75 120H86.25C90.2344 120 93.75 116.719 93.75 112.5V90C93.75 86.0156 90.2344 82.5 86.25 82.5ZM82.5 108.75H67.5V93.75H82.5V108.75ZM30 82.5H7.5C3.28125 82.5 0 86.0156 0 90V112.5C0 116.719 3.28125 120 7.5 120H30C33.9844 120 37.5 116.719 37.5 112.5V90C37.5 86.0156 33.9844 82.5 30 82.5ZM26.25 108.75H11.25V93.75H26.25V108.75Z",
    fill: "#516393"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationManagementInactive);
export default __webpack_public_path__ + "static/media/organization-management-inactive.61fbefe48cd2dbe4c06980a3eaa8af24.svg";
export { ForwardRef as ReactComponent };